<template>
    <div class="form-group col-md-12 row" style="padding: 2px !important; margin:0 !important;">

        <div
            class="form-group col-md-4">
            <label
                for="date_start">Date Start <required-field></required-field></label>
            <input type="date" name="date_start" id="date_start" class="form-control" v-model="form.date_start">
        </div>

        <div
            class="form-group col-md-4">
            <label
                for="date_end">Date End <required-field></required-field></label>
            <input type="date" name="date_end" id="date_end" class="form-control"
                   v-model="form.date_end">
        </div>


        <div
            class="form-group col-md-4">
            <label
                for="contract_length">Contract Length</label>
            <input type="number" name="contract_length" id="contract_length"
                   class="form-control" readonly
                   v-model="form.contract_length">
        </div>
    </div>
</template>

<script>
export default {
    name: "ContractServiceType",
    props: {
        contractId: {
            type: Number,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            form: {
                date_start: null,
                date_end: null,
                contract_length: null,
            }
        }
    },
    watch: {
        '$store.state.generic.currentYear'(val) {
            this.getDates()
        },
        'form.date_start'(val) {
            this.$store.commit('generic/setStartDate', val)
        },
        'form.date_end'(val) {
            this.$store.commit('generic/setEndDate', val)
        },
    },
    methods: {

        async getDates() {
            let app = this;
            this.loading = true;

            await axios.get('/contracts/' + this.contractId + '/contract-dates?year=' + this.$store.getters['generic/getCurrentYear'])
                .then((resp) => {
                    app.form = resp.data.data;
                    app.$store.commit('generic/setStartDate', app.form.date_start)
                    app.$store.commit('generic/setEndDate', app.form.date_end)
                    app.$forceUpdate()
                }).finally((e) => {
                    setTimeout(function () {
                        app.loading = false
                    }, 2000)
                })
        },
    },
    async mounted() {

        await this.getDates()
    }
}
</script>

<style scoped>

</style>
